define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"Apparel/CopyStyleMixin"
], function (declare, Copy, CopyStyleMixin) {

	return declare([Copy, CopyStyleMixin], {
		_toWriterSource: function () {
			this.preloadSourceNodes();
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Set the context properly so that the expression works
		 */
		onFormData: function (fd) {
			fd.setParent(this.m_cache.getNode(this.urlOwnerParent));
		},

		/**
		 * @override
		 * Fix the m_urlParent in the case of site level
		 */
		process: function () {
			// urlOwnerParent will be initialized once the copy controller starts, in this case, will be the url of Collection node
			// in the case of site level, the m_urlParent is gonna be the url of _CS_ApparelViews, which is not correct
			this.m_urlParent = this.urlOwnerParent;

			this.inherited(arguments);
		},

		/**
		 * @override
		 * return remove ProductType from automatic ChangeNode
		 * C8-50236 - Fix Performance Issue
		 */
		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd, /*Function*/filter) {
			// swallow product type
			fd = fd || this.m_formData; // in case form data isn't loaded yet
			fd.getFieldValue("ProductType", true);
			this.inherited(arguments);
		}
	});
});